module.exports = __webpack_public_path__ + "img/arrow.a4a8fb16.png";